<template>
  <div
    class="main"
    data-app="true"
  >
    <JumbotronView :message="message" />
    <v-app class="app-style mx-auto">
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
          md="8"
          offset-md="2"
        >
          <VerificationForm />
        </v-col>
      </v-row>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VerificationForm from './VerificationForm.vue';
import JumbotronView from '../JumbotronView.vue';

export default {
  name:       'VerificationPage',
  metaInfo: {
    title: 'Verify Your Information',
    meta: [
      {
        name: 'robots',
        content: 'noindex'
      }
    ]
  },
  components: {
    VerificationForm,
    JumbotronView,
  },
  props:    {},
  computed: {
    ...mapGetters(['firstName']),
    message() {
      return `Hi, ${this.firstName}. You're pre-qualified!`;
    },
  },
};
</script>

<style scoped lang="scss">
  #app.app-style.v-application {
    font-family: 'Open Sans';
    background-color: #F2F2F2;
    ::v-deep .v-application--wrap {
      min-height: auto;
    }
    @media (max-width: 768px) {
      padding: 0;
    }

    @media (min-width: 768px) {
      padding: 30;
    }
  }
</style>
